import React from "react";
import _ from "lodash";
import useMediaContext from "app/app/mediaSelector/hooks/use-media-context";

//Get all available terms in each taxonomy. Used for showing all filter options.
function useMediaTerms() {
    const mediaFiles = useMediaContext();

    const allCountryTerms = [];
    const allAreaTerms = [];
    const allTagTerms = []

    for(let i = 0; i < mediaFiles.length; i++) {
        if(mediaFiles[i].countryTerms) {
            allCountryTerms.push(...mediaFiles[i].countryTerms);
        }

        if(mediaFiles[i].areaTerms) {
            allAreaTerms.push(...mediaFiles[i].areaTerms);
        }

        if(mediaFiles[i].tagTerms) {
            allTagTerms.push(...mediaFiles[i].tagTerms)
        }
    }

    const availableCountryTerms = _.uniqBy(allCountryTerms, 'term_id');
    const availableAreaTerms = _.uniqBy(allAreaTerms, 'term_id');
    const availableTagTerms = _.uniqBy(allTagTerms, 'term_id');


    return {availableCountryTerms, availableAreaTerms, availableTagTerms};
}

export default useMediaTerms;
